import { FAKE, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { BasketContact } from 'components/ordering/acl/internal-types.js'


export const LOCALLY_STORED_BASKET_CONTACT = Symbol('LOCALLY_STORED_BASKET_CONTACT')
export type LocallyStoredBasketContact = {
  get contact(): BasketContact
  set contact({ name, telephone }: BasketContact)
}


@registerDependency(FAKE, LOCALLY_STORED_BASKET_CONTACT)
export class FakeLocallyStoredBasketContact implements LocallyStoredBasketContact {
  storedName: string = ''
  storedTelephone: string = ''

  get contact(): BasketContact {
    return { name: this.storedName, telephone: this.storedTelephone }
  }

  set contact({ name, telephone }: BasketContact) {
    this.storedName = name
    this.storedTelephone = telephone
  }
}


@registerDependency(REAL, LOCALLY_STORED_BASKET_CONTACT)
export class RealLocallyStoredBasketContact implements LocallyStoredBasketContact {
  private readonly localStorage = window.localStorage
  private readonly nameKey: string = 'csc-basket-contact-name'
  private readonly telephoneKey: string = 'csc-basket-contact-telephone'

  get contact(): BasketContact {
    const name = this.localStorage.getItem(this.nameKey) ?? ''
    const telephone = this.localStorage.getItem(this.telephoneKey) ?? ''
    return { name, telephone }
  }

  set contact({ name, telephone }: BasketContact) {
    this.localStorage.setItem(this.nameKey, name)
    this.localStorage.setItem(this.telephoneKey, telephone)
  }
}
